<template lang="pug">
  div#div-alert(v-if="alert == true && $store.getters.alertOn == true")
    div#mute-btn(v-if="alerted" @click="muteAlert" style="cursor: pointer;")
      i.fas.fa-volume-mute.fa-lg.text-danger
    //- iframe#audio(allow="autoplay" style="display:none")
    audio#player
      source(src="/test.mp3" type="audio/mp3")
</template>
<script>
import $ from 'jquery';

export default {
  props: {
    alert:{
      type: Boolean
    },
    randomKey:{
      type: String
    }
  },
  data() {
    return {
      alerted: false,
      intervalId: null
    }
  },
  watch: {
    randomKey: {
      handler(newVal) {
        this.loopPlay();
      }
    }
  },
  destroyed() {
  },
  mounted: function() {
  },
  methods:{
    loopPlay() {
      if (this.$store.getters.alertOn == true && this.alert == true) {
        this.playAlert();
      }
    },
    playAlert() {
      if (this.alerted == false) {
        if (this.$store.getters.alertOn == true) {
          var vid = document.getElementById("player");
          var promise = vid.play();
          if (promise !== undefined) {
            promise.then(_ => {
            }).catch(error => {
              // this.showModal();
              this.alerted = true;
            });
          }
        }
      } else {
        // var vid = document.getElementById("player");
        // $("#vid").click();
      }
    },
    muteAlert(){
      // this.$emit('muteAlert', true);
      this.alerted = false;
    }
  }
}
</script>


